import {RequestState} from "modules/enums";
import {createAction} from "redux-act";

interface IUserLoginPayload {
	uid: string;
	platform: string;
	isOptIn: boolean | null;
}

export const userLogin = createAction<IUserLoginPayload>("User Login");
export const userLoginWithAcceptTerms = createAction<IUserLoginPayload>(
	"User Login with accept terms"
);

export const userLogoutSuccess = createAction();

export const postLoginViaBackDoor = createAction<FormData>();
export const getSessionUser = createAction();

interface IUserResponse {
	user: {
		id: number;
		email: string;
		uid: string | null;
		birthday: string | null;
		username: string;
		isNotificationsEnabled: boolean;
		platform: string;
		avatar: string | null;
		isTutorialViewed: boolean;
		isSecondTutorialViewed: boolean;
		isTutorialOpenForced: boolean;
		isTooltipViewed: boolean;
		isBubbleViewed: boolean;
		isBannerViewed: boolean;
		isRewardModalViewed: boolean;
		isGameMessageViewed: boolean;
		isOptIn: boolean;
		countryCode: string | null;
		stateCode: string | null;
		ontarioTerms: boolean;
	};
}

export const retrieveUserSuccess = createAction<IUserResponse>();
export const postLoginViaBackDoorError = createAction();
export const setSessionState = createAction<RequestState>();
export const postUserLogout = createAction();
export const postUserLogoutSuccess = createAction();
export const postUserLogoutSuccessDebug = createAction();

export const enableMulliganAction = createAction();
export const setTutorialViewState = createAction();
export const setBannerViewState = createAction<{bannerViewsCount: number}>();
export const setSecondTutorialViewState = createAction();
export const setGameMessageViewState = createAction();
export const setTooltipModalState = createAction();
export const saveTooltipInsightsViewState = createAction();

interface ICheckTermsResponse {
	user: {
		terms: boolean;
	};
}

export const checkTerms = createAction<Pick<IUserLoginPayload, "uid">>();
export const checkTermsSuccess = createAction<ICheckTermsResponse>();
export const checkTermsFailed = createAction();

export const acceptTerms = createAction();

export const checkUserName = createAction<Pick<IUserLoginPayload, "uid">>();

interface ICheckUserNameResponse {
	user: {
		username: boolean;
		countryCode: string | null;
		stateCode: string | null;
	};
}

export const checkUserNameSuccess = createAction<ICheckUserNameResponse>();
export const checkUserNameFailed = createAction();

export const getCountry = createAction();

export interface IGetCountry {
	isoCode: string;
	isoStateCode: string;
}

export const getCountrySuccess = createAction<IGetCountry>();

interface ICheckGeoResponse {
	isAllowed: boolean;
}

export const checkGeo = createAction();
export const checkGeoSuccess = createAction<ICheckGeoResponse>();

export const fetchFavoritePlayers = createAction();

interface IFavoritePlayers {
	favoritePlayerIds: number[];
	mostSelectedPlayerIds: number[];
}

export const fetchFavoritePlayersSuccess = createAction<IFavoritePlayers>();
export const fetchFavoritePlayersFailed = createAction();

export const fetchFavoriteSquads = createAction();

interface IFavoriteSquads {
	favoriteSquadIds: number[];
}

export const fetchFavoriteSquadsSuccess = createAction<IFavoriteSquads>();
export const fetchFavoriteSquadsFailed = createAction();

export const setForceTutorialModal = createAction<boolean>();

export const actionEnableGodMode = createAction();

export const setViewRewardModal = createAction();
export const setViewRewardModalSuccess = createAction<IUserResponse>();

export interface IUserRewardsResponse {
	rewards: string[];
}
export const fetchUserRewards = createAction();
export const fetchUserRewardsSuccess = createAction<IUserRewardsResponse>();
export const fetchUserRewardsError = createAction();
